import { render, staticRenderFns } from "./HotCommunities.vue?vue&type=template&id=0d4d14ba&scoped=true"
import script from "./HotCommunities.vue?vue&type=script&lang=js"
export * from "./HotCommunities.vue?vue&type=script&lang=js"
import style0 from "./HotCommunities.vue?vue&type=style&index=0&id=0d4d14ba&prod&lang=css"
import style1 from "./HotCommunities.vue?vue&type=style&index=1&id=0d4d14ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d14ba",
  null
  
)

export default component.exports